import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React from "react";

const useStyles = makeStyles((theme) => ({
  dialog: {
    width: "45%",
    borderRadius: "15px",
    background: "#004990",
    color: "white",
    padding: "1em",
    marginTop: "1em",
    marginBottom: "1em",
    [theme.breakpoints.down("md")]:{
      width:"75%",
    },
    [theme.breakpoints.down("lg")]:{
      width:"60%",
    }
  },
  owner: {
    background: "#BDBDBD",
    float: "right",
  },
}));

export default function Bubble({ isOwner, message }) {
  const { content } = message;
  const { dialog, owner } = useStyles();
  return (
    <Box>
      <Box className={[dialog, isOwner ? owner : ""]}>
        <Typography>{content}</Typography>
        {/* <Typography textAlign="end" marginTop="0.5em">
          00:00 pm
        </Typography> */}
      </Box>
    </Box>
  );
}
